import axios, { Axios } from "axios";
import LocalStorage from "../utils/LocalStorage";
import { refreshAccessToken } from "../actions";


const api = axios.create();


api.defaults.timeout = 60000;
//api.defaults.baseURL = SERVER_BASE_URL;
api.defaults.baseURL = process.env.REACT_APP_BASE_URL;

const pendingRequests = new Map();
api.interceptors.request.use(
    async config => {
      const token = LocalStorage.getToken()
        const lang = LocalStorage.getItem('i18nextLng') === 'zh'?'zh':LocalStorage.getItem('i18nextLng') === 'en'?'en':'fr'

        if(token){
            config.headers = {
                'Authorization': `Bearer ${token}`,
                'Accept': 'application/json',
                'Language': lang
            }
        } else {
            config.headers = {
                'Accept': 'application/json',
                'Language': lang
            }
        }

        // 创建请求的唯一标识符

      return config;
    },
    error => {
      Promise.reject(error)
    });

api.interceptors.response.use((response) => {

  return response
}, async function (error) {
    if (error instanceof axios.Cancel) {
        // 这里处理取消请求的逻辑
        return console.log('请求被取消了：', error.message);
    }

    if (error.code === 'ECONNABORTED') {
        // 处理超时错误
        return Promise.reject(new Error('Request timed out, please try again later'));
    }

  const originalRequest = error.config;
  if (error.response.status === 403 && !originalRequest._retry) {
    originalRequest._retry = true;
    await refreshAccessToken();
    return api(originalRequest);
  }
    if (error.response.status === 401){
        window.open('/', '_self');
    }
  return Promise.reject(error);
});

export default api
